/**
 * Transforms a Supabase Storage public URL to use the image transformation API.
 * This enables on-the-fly resizing, format conversion (WebP), and quality adjustment,
 * drastically reducing image payload sizes.
 *
 * Non-Supabase URLs are returned unchanged.
 */
export function optimizeImageUrl(
  url: string,
  options: { width?: number; quality?: number } = {}
): string {
  if (!url) return url;

  const { width = 800, quality = 75 } = options;

  // Only transform Supabase storage URLs
  const storagePattern = /\/storage\/v1\/object\/public\//;
  if (!storagePattern.test(url)) return url;

  // Replace /object/ with /render/image/ for the transformation endpoint
  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/"
  );

  const separator = transformed.includes("?") ? "&" : "?";
  return `${transformed}${separator}width=${width}&quality=${quality}`;
}
